<template>
  <!-- フッターの黄色枠 -->
  <div class="book_footer actions">
    <ul>
      <!-- 払い戻しボタン -->
      <BFaceRefundButton v-if="isRefundable" />

      <!-- 譲渡ボタン -->
      <BFaceTransferButton v-if="isTransferable" />

      <!-- 返却ボタン -->
      <BFaceRestoreButton v-if="isRestorable" :book-id="book.id" />

      <!-- サブスクリプションの自動更新解除ボタン -->
      <BFaceStopSubscriptionButton v-if="isSubscribable" />
    </ul>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

import bookService from "@/services/book";
import mfittService from "@/services/MFITT";

export default {
  name: "TheBookFooter",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);

    // 使用済みの引換券がある場合は払い戻し不可
    const isRefundable = computed(
      () =>
        bookService.checkIsRefundable(masterBook.value, book.value) &&
        !mfittService.checkHasUsedCouponsWithBook(
          myCoupons.value,
          book.value.id
        )
    );
    const isRestorable = computed(() =>
      bookService.checkIsRestorable(masterBook.value, book.value)
    );
    const isSubscribable = computed(() =>
      bookService.checkIsSubscribable(masterBook.value, book.value)
    );
    const isTransferable = computed(() =>
      bookService.checkIsTransferable(masterBook.value, book.value)
    );

    return {
      book,
      masterBook,
      isRefundable,
      isTransferable,
      isRestorable,
      isSubscribable,
    };
  },
};
</script>

<style lang="scss" scoped>
.book_footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.actions {
  background-color: #ffb206;
  padding: 0;
}
</style>
